import { render } from "./DefaultSwitcher.vue?vue&type=template&id=0007e573&scoped=true"
import script from "./DefaultSwitcher.vue?vue&type=script&lang=js"
export * from "./DefaultSwitcher.vue?vue&type=script&lang=js"

import "./DefaultSwitcher.vue?vue&type=style&index=0&id=0007e573&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0007e573"]])

export default __exports__